<h3 mat-dialog-title>Plaid Balance History for {{data.unifiedBankAccount.friendlyName}}</h3>

<mat-dialog-content class="p-0">
    <div class="d-loading" *ngIf="loading">
        <div class="loader">Loading...</div>
    </div>
    <table *ngIf="!loading" class="table">
        <thead>
        <tr>
            <th>Date</th>
            <th class="text-right">Balance</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of history">
            <td>{{row.createdAt | legfiDate:'MM/DD/YYYY h:mm a'}}</td>
            <td class="text-right">{{row.balance | legfiCurrency:'USD':'symbol':'.2'}}</td>
        </tr>
        </tbody>
    </table>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-dialog-close class="btn btn-outline-secondary">
        Close
    </button>
</mat-dialog-actions>
